import {
    CrudBase
} from "../../crud";
import {
    BasicCrud
} from "../../../utils/interfaces/crud/imp/crud-basic";
import {
    ContentSectionModel
} from "../../../models/content";


export class _ContentSectionController extends CrudBase {
    createModel = ContentSectionModel;
    loading = false;
    list = []
    selectedContent = null
    // formData 
    constructor() {
        super({
            name: "content_section",
            modules: {
                crud: new BasicCrud()
            },
            model: ContentSectionModel
        });
    }

    onReady() {
        this.actions = this.repo.content;
        // this.routes.edit = "/Questionnaire/Maintenance/"
    }

    async getAllSections() {
        let response = await this.execute(this.actions.getAllSections, null, `?ContentId=${this.app.$route.params.id}`)
        if (response.success) {
            this.list = response.data
            this.selectedContent = this.list[0]
        }
    }

    async onEdit(item) {
        this.app.$refs.contentTextDialog.open(item, "content_section", "updateSection")
    }

    createContentSection(type)
    {
        let newSection = new ContentSectionModel()
        newSection.type = type;
        newSection.contentId = this.app.$route.params.id
        this.app.$refs.contentTextDialog.open(newSection, "content_section", "onSectionCreated")
    }

    async onSectionCreated(item){
        let response = await this.execute(this.actions.createSection, item )
        if (response.success) {
            console.log(response.data);
            this.list.push(response.data)
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: "Content section successfully created"
              })
        }
    }

    async updateSection(item) {
        let response = await this.execute(this.actions.updateSection, item, `?id=${item.id}`)
        if (response.success) {
            this.list[this.list.indexOf(item)] = response.data
            console.log(response.data);
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: "Content section successfully updated"
              })
        }
    }

    delete(item) {
        this.app.$refs.confirmationDialog.showDialog({
            title: `Delete Content section`,
            message: `Are you sure you wish to delete this content section?`,
            callback: "onDeleted",
            callbackData: item,
            controller: "content_section"
        });
    }

    async onDeleted(item) {
        let response = await this.execute(this.actions.deleteSection, null, `?id=${item.id}`);
        if (response.success) {
            this.list.splice(this.list.indexOf(item), 1);
            this.execute(this.actions.deleteImage,null,`?Id=${item.mediaId}`)
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: "Content section successfully deleted"
              })
        }
    }

    cycleContent(){
        let currentIDX = this.list.indexOf(this.selectedContent)
        if (currentIDX + 1 != this.list.length) {
          this.selectedContent = this.list[currentIDX + 1]
        }else{
          this.selectedContent = this.list[0]
        }
    }
}
export const ContentSectionController = new _ContentSectionController();